import React from 'react';
import { StyledCaptions } from './Captions.styles.mjs';

const Captions = ({ text, isFullScreen }) => {
    return React.createElement(StyledCaptions, { isFullScreen: isFullScreen }, text);
};

export { Captions as default };
//# sourceMappingURL=Captions.mjs.map
